/* eslint-disable max-lines */
export default {
  new_feature_notification: {
    check_out_new_feature: 'Schau dir die neue Funktion an!'
  },
  change_request_modal: {
    title: 'Änderungsantrag eingereicht',
    message:
      'Ihr Bearbeitungsantrag wurde erfolgreich eingereicht. Bitte warten Sie auf die Genehmigung durch den Administrator, bevor Sie fortfahren.',
    got_it: 'Verstanden'
  },
  blocked_app_modal: {
    title: 'Konto gesperrt',
    message: 'Ihr Konto wurde gesperrt. Für weitere Informationen wenden Sie sich bitte an den Administrator.',
    contact_admin: 'Administrator kontaktieren',
    additional_info:
      'Wenn Sie glauben, dass dies ein Fehler ist oder sofortige Hilfe benötigen, wenden Sie sich bitte an unser Support-Team. Wir entschuldigen uns für eventuelle Unannehmlichkeiten.'
  },
  captcha_page: {
    title: 'Bitte bestätigen Sie, dass Sie ein Mensch sind, um fortzufahren.',
    error: 'Überprüfung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    expired: 'Die Überprüfung ist abgelaufen. Bitte versuchen Sie es erneut.',
    load_error: 'Die Überprüfung konnte nicht geladen werden. Bitte aktualisieren Sie die Seite.',
    verifying: 'Überprüfung...'
  },
  phone_confirmation_modal: {
    title: 'Telefonnummer bestätigen',
    description: 'Geben Sie Ihre Telefonnummer ein. Wir senden eine SMS an diese Nummer.',
    phone: 'Telefonnummer',
    phone_placeholder: '+48 111 222 333',
    send_sms: 'SMS senden',
    sending: 'Wird gesendet...',
    sent: 'Die SMS wurde gesendet.',
    too_soon: 'Warten Sie eine Minute, bevor Sie eine weitere SMS senden.',
    limit_reached: 'Sie können höchstens 5 SMS pro Stunde senden. Versuchen Sie es später erneut.',
    phone_required: 'Telefonnummer ist erforderlich',
    error: 'SMS konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    code: 'Code aus der SMS',
    code_placeholder: '123456',
    confirm: 'Bestätigen',
    confirming: 'Wird bestätigt...',
    invalid_code: 'Der Code ist falsch.',
    code_required: 'Geben Sie den Code aus der SMS ein.',
    confirm_error: 'Die Telefonnummer konnte nicht bestätigt werden. Bitte versuchen Sie es erneut.'
  },
  demo_modal: {
    demo_expired: 'Demo abgelaufen',
    title: 'Wir helfen Ihnen',
    title_highlight: 'den vollen Zugang zu aktivieren.',
    subtitle: 'Haben Sie Fragen zur Plattform? Wir sind hier, um zu helfen.',
    badge: 'Vollzugang für Händler',
    full_access_title: 'Vollzugang',
    full_access_description: 'Für Händler, die bereit sind, Motorräder zu beschaffen und Gewinn zu erzielen.',
    price: '990€',
    price_period: '/ einmalige Zahlung',
    features: {
      live_listings: 'Vollzugang zu aktuellen, verifizierten Angeboten von Privatverkäufern',
      bid_buy: 'Vollständige Möglichkeit zu bieten oder zu kaufen, mit vollständiger Kontrolle über den Transport',
      priority_support: 'Prioritätsbetreuung und Händler-Support',
      mobile_app: 'Vollzugang zur mobilen App'
    },
    support_text:
      'Wenn Sie Fragen zu diesem Schritt oder der Plattform selbst haben, schreiben Sie uns an partner@estigroup.de — unser Team antwortet schnell, um Ihnen beim Start zu helfen.',
    form: {
      title: 'Vervollständigen Sie Ihre Firmendaten, um den vollen Kaufzugang freizuschalten',
      description:
        'Wir benötigen diese Informationen, um Ihre Händlervereinbarung vorzubereiten und Ihre Möglichkeit zu aktivieren, Fahrzeuge auf der Plattform zu kaufen.',
      company_id: 'Firmen-ID',
      company_id_placeholder: 'Ihre ID',
      company_name: 'Firmenname',
      company_name_placeholder: 'Name der Firma',
      address: 'Adresse',
      address_placeholder: 'Straßenname',
      city: 'Stadt',
      city_placeholder: 'Stadtname',
      postal_code: 'Postleitzahl',
      postal_code_placeholder: 'Postleitzahl',
      phone_number: 'Telefonnummer',
      phone_number_placeholder: 'Ihre Telefonnummer',
      privacy_policy:
        'Durch die Übermittlung meiner Daten bestätige ich, dass ich die Estimoto-Datenschutzrichtlinie gelesen und verstanden habe',
      submit_button: 'Vollzugang anfordern',
      errors: {
        company_id_required: 'Firmen-ID ist erforderlich',
        company_name_required: 'Firmenname ist erforderlich',
        address_required: 'Adresse ist erforderlich',
        city_required: 'Stadt ist erforderlich',
        postal_code_required: 'Postleitzahl ist erforderlich',
        phone_number_required: 'Telefonnummer ist erforderlich',
        privacy_policy_required: 'Sie müssen die Datenschutzrichtlinie akzeptieren'
      }
    }
  },
  test_access_banner: {
    demo_mode: 'Demo-Modus',
    expires_on: 'Läuft ab am',
    contact_support: 'Support kontaktieren',
    upgrade_now: 'Jetzt upgraden'
  },
  pagination: {
    showing_items: '{{startItem}}-{{endItem}} von {{totalItems}} Ergebnissen'
  },
  only_buy_now_dec: 'Nur Angebote anzeigen',
  only_buy_now: 'Sofort-Kauf',
  just_sold: 'Verkaufte Fahrzeuge',
  in_realization_list_item: {
    contact_info: 'Kontakt',
    email: 'E-mail',
    phone: 'Telefon',
    help: 'Hilfe',
    arrange_transport: 'Spedition beauftragen',
    transport_arranged: 'Spedition beauftragt',
    transport_arranged_long: 'Das Fahrzeug wurde an die Spedition übergeben',
    confirm_receipt: 'Abholung bestätigen',
    vehicle_data: 'Spezifikation',
    contract_pdf: 'Übergabebestätigung',
    spedition: 'Spedition mit der Abholung beauftragen',
    choose_spedition: 'Spedition wählen',
    spedition_note: 'Nachricht an die Spedition',
    spedition_terms_1: 'Mit der Beauftragung akzeptierst du die Preise und AGB der gewählten Spedition.',
    create_transport_button: 'Auftrag senden',
    confirm_pick_up: 'Das Fahrzeug wurde erfolgreich angekauft und abgeholt.',
    confirm_button: 'Abholung bestätigen',
    cancel: 'Abbrechen',
    accepted: 'Akzeptiert',
    credit_data: 'Kreditdetails',
    price: 'Fahrzeugpreis',
    provision: 'Provision',
    deregistering_person: 'Fahrzeugabmeldung',
    deregistering_person_dealer: 'Käufer (Händler)',
    deregistering_person_seller: 'Verkäufer',
    deregistering_person_later: 'Später entscheiden',
    deregistering_person_already_deregistered: 'Ist bereits abgemeldet'
  },
  invoices_screen: {
    screen_title: 'Rechnungen'
  },
  bottom_menu: {
    sell: 'Verkauf',
    search: 'Suchen',
    want_to_buy: 'Ankauf',
    settings: 'Einstellungen'
  },
  platform_terms: {
    title: 'AGB',
    files: [
      {
        label: 'Allgemeine zusätzliche Geschäftsbedingungen (AGB-Z)',
        href: '/Allgemeine zusätzliche Geschäftsbedingungen (AGB-Z).pdf'
      },
      { label: 'AGB Estigroup (DE)', href: '/AGB-ESTIGROUP-DE.pdf' }
    ]
  },
  soon: 'in Vorbereitung',
  buy_now_modal: {
    title: 'Fahrzeug sofort kaufen',
    by_clicking: 'mit dem Kauf bestätigst du unsere',
    buy_now: 'AGB',
    you_realize_sell: 'und',
    terms: 'Datenschutzerklärung',
    buy_now_button: 'Bestätigen',
    realization: 'Verkäufer kontaktieren',
    you_offer_has_been_sent: 'Herzlichen Glückwunsch \n Du kannst den Verkäufer \n jetzt kontaktieren.',
    go_to_realization:
      'Vereinbare in den nächsten 48h einen Übergabetermin oder beauftrage eine Spedition mit der Abholung.'
  },

  auction_contract_modal: {
    by_clicking: '',
    you_are_accepting: '',
    title: 'Biete einen fairen und realistischen Preis.',
    term: 'Dein Angebot ist <strong>14 Tage</strong> bindend. \n Mit der Gebotsabgabe akzeptierst du unsere <strong>AGB</strong>.',

    price: 'Preis.\n',
    offer_time: 'Dein Angebot',
    offer_time_span: 'ist 14 Tage bindend.',
    resign: 'Abbrechen',
    place_offer: 'Bieten',
    place_offer_title: '',
    go_to_bets: 'meine Angeboten',
    your_offer_has_been_sent: 'Das Angebot wurde übermittelt.',
    go_to_bets_desc: 'Gehe zu deinen Ankäufen, \n um den weiteren Verlauf zu verfolgen.',
    only_fail_offer_will_be_sent: `
    Wenn dein Angebot zu weit von einem realistischen Ankaufspreis abweicht, \n sind wir nicht verpflichtet es an den Verkäufer zu senden.
    In deinen Ankäufen \n kannst du den aktuellen \n Status deiner Angebote sehen.`,
    we_will_notify: ''
  },
  single_offer: {
    check_price_on_mobile: 'Preis überprüfen',
    roadworthy: 'Fahrbereit',
    not_roadworthy: 'Nicht fahrbereit',
    gross_vehicle_weight: 'zulässige Gesamtmasse',
    length: 'Länge',
    width: 'Breite',
    engine_capacity: 'Hubraum',
    engine_power: 'Leistung',
    automatic_gearbox: 'Automatikgetriebe',
    date_of_first_registration: 'Erstzulassung',
    year_of_production: 'Erstzulassung',
    added: 'Veröffentlicht vor',
    ago: '-',
    unread_messages: 'Nachricht',
    screen_title: 'Fahrzeugdetails',
    gallery: 'Bilder',
    your_highest: 'Dein Angebot',
    buy_now: 'Sofort-Kauf',
    minimal_price: 'Preisvorstellung',
    place_an_offer: 'Bieten',
    place_an_different_offer: 'anderes Angebot platzieren',
    buy_now_button: 'Sofort-Kauf',
    vehicle_description: 'Fahrzeugdetails',
    first_registration: 'Erstzulassung',
    total_mileage: 'Laufleistung',
    zip_code: 'PLZ',
    origin_country: 'Herkunftsland',
    import_description_options: {
      germany: 'Deutschland',
      austria: 'Austria',
      italy: 'Italien',
      netherlands: 'Niederlande',
      usa: 'USA',
      great_britain: 'Großbritannien',
      france: 'Frankreich',
      belgium: 'Belgia',
      not_known: 'unbekannt',
      other: 'andere'
    },
    rental_description: 'Art der Nutzung',
    rental_description_options: {
      demo: 'Vorführmotorrad',
      driving_course: 'Fahrschulmotorrad',
      rental: 'Mietmotorrad'
    },
    used_commercially: 'Kommerziell genutzt',
    not_rental: 'keine kommerzielle Nutzung',
    previous_owners: 'Anzahl der Vorbesitzer',
    number_of_previous_owners_options: {
      _0_: '0',
      _1_: '1',
      _2_: '2',
      _3_: '3',
      _4_: '4',
      more_than_4: 'mehr als 4',
      not_known: 'unbekannt'
    },
    addiction_info: 'Weitere Informationen',
    accident_free: 'Unfallfrei',
    with_accident: 'Unfallfahrzeug',
    not_wrecked: 'Umkippfrei',
    wrecked: 'Umkipper',
    original_lacquer: 'Originallackierung',
    not_original_lacquer: 'kein Originallack',
    without_defects: 'keine anderen Schäden',
    defects: 'andere Schäden/Mängel',
    with_trailer: 'Mit Transportanhänger',
    without_trailer: 'Ohne Transportanhänger',
    accessories_description: 'Ausstattung und Zubehör',
    admin_comment: 'Kommentare',
    not_financed_vehicle: 'nicht finanziert',
    financed_vehicle_1: 'finanziert',
    abs: 'ABS',
    vin: 'Fahrgestellnummer',
    without_abs: 'kein ABS',
    not_imported: 'kein Importfahrzeug',
    with_service_booklet: 'Scheckheft',
    motorbike_service_booklet_options: {
      not_run: 'kein Scheckheft',
      existing: 'Scheckheft vorhanden',
      run: 'geführtes Scheckheft',
      digitally_run: 'digital geführtes Scheckheft'
    },
    not_categorized_attributes_section_title: 'Fahrzeugdetails',
    general_condition_section_title: 'Fahrzeugzustand',
    score: 'Scoring',
    general_condition: 'Allgemeiner Zustand',
    consumables_condition: 'Verschleißteile',
    tires: 'Reifen',
    tires_age: 'Reifenalter',
    tires_condition: 'Reifenprofil',
    motorbike_general_condition_options: {
      as_new: 'Neuwertiger Zustand',
      well_maintained: 'Sehr gut',
      average: 'Leichte Gebrauchsspuren',
      bad: 'Verunfallt / beschädigt',
      care: 'Pflegebedürftig',
      tatty: 'Mangelhaft'
    },
    motorbike_consumables_condition_options: {
      as_new: 'Neuwertig',
      well_maintained: 'Gut',
      average: 'Befriedigend',
      tatty: 'Mangelhaft',
      not_known: 'unbekannt',
      bad: 'Schlecht',
      care: 'Ausreichend'
    },
    motorbike_tires_options: {
      '25%': '25%',
      '50%': '50%',
      '75%': '75%',
      bad: 'Abgefahren oder älter als 6 Jahre',
      very_well: 'Neuwertig',
      not_known: 'unbekannt'
    },
    motorbike_tires_age_options: {
      under_six_years_old: 'Unter 6 Jahren',
      over_six_years_old: '6 Jahre oder älter',
      not_known: 'Ich kenne mich nicht aus'
    },
    motorbike_tires_condition_options: {
      _0_: 'Abgefahren',
      _25_: '25%',
      _50_: '50%',
      _75_: '75%',
      _100_: 'Neu',
      not_known: 'Ich kenne mich nicht aus'
    },
    services: 'Inspektionen',
    motorbike_last_inspection: 'Letzte Inspektion',
    motorbike_next_hu: 'Nächste HU',
    photos_screen_title: 'Galerie',
    camper_number_of_seats: 'Anzahl der Sitzplätze',
    camper_commercial_use: 'kommerziell genutzt',
    camper_without_commercial_use: 'keine kommerzielle Nutzung',
    bool_options: {
      true: 'Ja',
      false: 'Nein'
    },
    camper_type: 'Fahrzeugtyp',
    camper_type_options: {
      caravan: 'Wohnwagen',
      van: 'Kastenwagen/CUV',
      semi_integrated: 'Teilintegrierter',
      fully_integrated: 'Vollintegrierter',
      alcove: 'Alkoven',
      luxury: 'Luxus-Liner',
      car: 'PKW'
    },
    camper_next_hu: 'Nächste HU',
    camper_last_inspection: 'Letzte Inspektion',
    agricultural_production_year: 'Baujahr',
    agricultural_meter: 'Laufleistung',
    agricultural_general_condition_options: {
      as_new: 'neu',
      well_maintained: 'leicht gebraucht',
      average: 'genutzt',
      bad: 'reparaturbedürftig',
      care: '',
      tatty: ''
    }
  },
  browse: 'Fahrzeuge',
  all_vehicles: 'Alle Fahrzeuge',
  liked_vehicles: 'Favoriten',
  first_offer: 'ohne Gebot',
  highest_offer: 'Überboten',
  highest_offer_short: 'Höchstgebot',
  first_offer_short: 'ohne Gebot',
  buy_now: 'Sofort-Kauf',
  no_offers: 'Momentan gibt es keine Fahrzeuge \n die deine Kriterien erfüllen.',
  offer_to_low: 'Mindestgebot € ',
  date: 'EZ',
  agricultural_production_year: 'Baujahr',
  mileage: 'Laufleistung',
  country: 'Standort',
  bets_count: 'Anzahl der Gebote',
  your_offer: 'Dein Gebot',
  buy_now_expanded_view: 'Sofort-Kauf',
  minimal_offering: 'Preisvorstellung',
  new_offer_button: 'Bieten',
  buy_now_button: 'Sofort-Kauf',
  bets_table_title: 'Deine Gebote',
  archive_tab_title: 'Archiwum skupowane',
  sold_tab_title: 'Angekauft',
  company_data_title: 'Firmendaten',
  company_data: 'Firmendaten',
  in_realization_table: 'Abwicklungen',
  messages: 'Nachrichten',
  auctions: 'Meine Gebote',
  in_realization: 'Abwicklungen',
  invoices: 'Rechnungen',
  archive: 'Archiv',
  my_auctions: 'Ankauf',
  accepted_offer: 'Angebot angenommen',
  archived_date: 'Archiviert',
  sold: 'Verkaufsarchiv',
  app_should_be_updated: 'Eine neue App-Version ist verfügbar',
  update: 'Aktualisierung',
  Motorbike_offers: 'Motorräder',
  JetSki_offers: 'Jetski',
  AgriculturalMachine_offers: 'Landmaschinen',
  Camper_offers: 'Wohnmobile und -wagen',
  message_placeholder: 'Nachricht schreiben',
  application_version: 'App-Version',
  remove_account: 'Konto entfernen',
  log_out: 'Abmelden',
  profile: 'Profil',
  profile_settings: 'Stammdaten',
  auth_settings: 'APP-EINSTELLUNGEN',
  update_application: 'Aktualisierung',
  check_updates: 'Verfügbarkeit prüfen',
  remove_account_confirmation: 'Möchtest du das Konto wirklich löschen ?',
  set_password: 'Passwort festlegen',
  set_language: 'Sprache',
  integrations: 'Integrationen',
  integrations_screen: {
    title: 'Integrationen',
    login: 'Login',
    password: 'Passwort',
    add: 'Integration hinzufügen',
    empty: 'Es ist noch keine Integration verbunden.',
    cancel: 'Abbrechen',
    connect: 'Verbinden',
    connected: 'Konto verbunden',
    seller_id: 'Verkäufer-ID',
    sync: 'Fahrzeuge synchronisieren',
    sync_started: 'Synchronisierung gestartet. Die Fahrzeuge erscheinen in der Fahrzeugliste.',
    connect_success: 'mobile.de-Konto wurde verbunden',
    connect_error: 'Konto konnte nicht verbunden werden',
    load_error: 'Integrationen konnten nicht geladen werden',
    sync_error: 'Synchronisierung konnte nicht gestartet werden',
    disconnect: 'Integration entfernen',
    disconnect_title: 'Integration entfernen?',
    disconnect_message:
      'Das Konto wird getrennt. Die Inserate bleiben auf mobile.de. Danach kannst du die Integration erneut hinzufügen, zum Beispiel mit einem neuen Passwort.',
    disconnect_confirm: 'Entfernen',
    disconnect_success: 'Integration wurde entfernt',
    disconnect_error: 'Integration konnte nicht entfernt werden'
  },
  profile_settings_screen_header: 'Einstellungen',
  save_password: 'Speichern',
  update_password_form: {
    current_password: 'Aktuelles Passwort',
    new_password: 'Neues Passwort',
    confirm_new_password: 'Passwort wiederholen',
    password_not_match: 'Die Passwörter stimmen nicht überein',
    password_do_not_meet_requirements:
      'Das Passwort sollte mindestens aus 8 Zeichen bestehen und einen Groß- und Kleinbuchstaben und ein Sonderzeichen Sonderzeichen wie „!@#$%^&*“ enthalten.',
    current_password_invalid: 'Das aktuelle Passwort ist falsch',
    password_to_short: 'Das Passwort ist zu kurz (mindestens 8 Zeichen)',
    unknown_error: 'Etwas ist schief gelaufen. Bitte versuche es erneut'
  },
  sign_in_screen: {
    do_not_have_account: 'Noch kein Konto ?',
    registration: 'Jetzt registrieren',
    registration_url: 'https://estigroup.de',
    title: 'Anmeldung',
    forgot_password: 'Passwort vergessen ?',
    sign_in: 'Anmelden',
    forgot_password_title: 'Passwort zurücksetzen',
    forgot_password_description:
      'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
    reset_password: 'Passwort zurücksetzen',
    remind_password: 'Senden',
    reset_instructions_sent: 'Anweisungen zum Zurücksetzen des Passworts wurden an Ihre E-Mail-Adresse gesendet',
    password_invalid: 'falsches Passwort',
    email_invalid: 'E-mail nieprawidłowy',
    repeat_password: 'Passwort wiederholen',
    password: 'Passwort',
    password_requirement_uppercase: 'Min. 1 Großbuchstabe',
    password_requirement_number: 'Min. 1 Zahl',
    password_requirement_special_char: 'Min. 1 Sonderzeichen (!#$%@*^&)',
    password_requirement_min_length: 'Min. 8 Zeichen'
  },
  profile_settings_form: {
    name: 'Name',
    last_name: 'Nachname',
    nickname: 'Vorname',
    phone: 'Telefon',
    email: 'E-mail',
    company_name: 'Firmenname',
    ftin: 'USt.-idNr.',
    street: 'Straße',
    zip_code: 'PLZ',
    place: 'Ort',
    iban: 'IBAN',
    bic: 'BIC',
    save: 'Speichern'
  },
  filter_modal: {
    localization: 'Standort',
    vehicle: 'Fahrzeug',
    hash_id: 'ID-Nummer',
    damaged_label: 'Fahrzeugzustand',
    damaged: 'Beschädigt',
    not_damaged: 'Nicht beschädigt',
    all: 'Alle',
    year_form: 'EZ von',
    year_to: 'EZ bis',
    milage_from: 'km von',
    milage_to: 'km bis',
    zpi_code_input: 'PLZ',
    area: 'Umkreis',
    country: 'Land',
    filter_offers: 'Suche eingrenzen',
    filter_button: 'Verstecken',
    motorbikes: 'Motorräder',
    agricultural_machines: 'Landmaschinen',
    campers: 'Wohnmobile und -wagen',
    vehicle_type: 'Fahrzeugart',
    motorbike_model: 'Modell',
    motorbike_brand: 'Marke',
    brand_options: [
      {
        optionLabel: 'Access Motor',
        optionVal: 33
      },
      {
        optionLabel: 'Aprilia',
        optionVal: 3
      },
      {
        optionLabel: 'BMW',
        optionVal: 2
      },
      {
        optionLabel: 'Benelli',
        optionVal: 18
      },
      {
        optionLabel: 'Beta',
        optionVal: 23
      },
      {
        optionLabel: 'Bimota',
        optionVal: 20
      },
      {
        optionLabel: 'Buell',
        optionVal: 4
      },
      {
        optionLabel: 'CFMoto',
        optionVal: 28
      },
      {
        optionLabel: 'Can Am',
        optionVal: 31
      },
      {
        optionLabel: 'Daelim',
        optionVal: 24
      },
      {
        optionLabel: 'Ducati',
        optionVal: 5
      },
      {
        optionLabel: 'Harley-Davidson',
        optionVal: 6
      },
      {
        optionLabel: 'Honda',
        optionVal: 1
      },
      {
        optionLabel: 'Husaberg',
        optionVal: 26
      },
      {
        optionLabel: 'Husqvarna',
        optionVal: 7
      },
      {
        optionLabel: 'Hyosung',
        optionVal: 25
      },
      {
        optionLabel: 'Indian',
        optionVal: 8
      },
      {
        optionLabel: 'KTM',
        optionVal: 10
      },
      {
        optionLabel: 'Kawasaki',
        optionVal: 9
      },
      {
        optionLabel: 'Kymco',
        optionVal: 22
      },
      {
        optionLabel: 'MV Agusta',
        optionVal: 12
      },
      {
        optionLabel: 'Moto-Guzzi',
        optionVal: 11
      },
      {
        optionLabel: 'Peugeot',
        optionVal: 27
      },
      {
        optionLabel: 'Piaggio',
        optionVal: 19
      },
      {
        optionLabel: 'Polaris',
        optionVal: 30
      },
      {
        optionLabel: 'Royal Enfield',
        optionVal: 32
      },
      {
        optionLabel: 'Suzuki',
        optionVal: 13
      },
      {
        optionLabel: 'TGB',
        optionVal: 29
      },
      {
        optionLabel: 'Triumph',
        optionVal: 14
      },
      {
        optionLabel: 'Vespa',
        optionVal: 21
      },
      {
        optionLabel: 'Victory',
        optionVal: 15
      },
      {
        optionLabel: 'Yamaha',
        optionVal: 16
      }
    ]
  },
  my_vehicles: {
    title: 'Meine Fahrzeuge',
    in_stock: 'Auf Lager',
    sold: 'Verkauft',
    add_vehicle: 'Fahrzeug hinzufügen',
    edit_vehicle: 'Fahrzeug bearbeiten',
    vehicle: 'Fahrzeug',
    actions: 'Aktionen',
    details: 'Fahrzeugdetails',
    mark_as_sold: 'Fahrzeug als verkauft markieren',
    mark_as_in_stock: 'Fahrzeug wieder auf Lager setzen',
    toast_marked_sold: '{{name}} als verkauft markiert',
    toast_restored_stock: '{{name}} wieder auf Lager gesetzt',
    toast_vehicle_fallback: 'Fahrzeug',
    toast_vehicle_added: 'Fahrzeug hinzugefügt',
    toast_issue_invoice: 'Rechnung ausstellen',
    documents: 'Dokumente',
    no_documents: 'Keine Dokumente für dieses Fahrzeug',
    photos: 'Fotos',
    photos_empty: 'Dieses Fahrzeug hat noch keine Fotos.',
    add_photo: 'Foto hinzufügen',
    delete_photo_title: 'Foto löschen?',
    delete_photo_message: 'Das Foto wird aus der Galerie dieses Fahrzeugs entfernt.',
    photo_added: 'Foto wurde hinzugefügt',
    photo_deleted: 'Foto wurde gelöscht',
    photo_type_error: 'Erlaubt sind nur JPEG- und PNG-Dateien.',
    photo_upload_error: 'Foto konnte nicht gespeichert werden',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    view_offer: 'Angebot ansehen',
    empty_title: 'Erstes Fahrzeug hinzufügen',
    empty_subtitle: 'Für jedes Motorrad stellen Sie Dokumente für Ihre Kunden aus.',
    sold_empty_title: 'Fahrzeug verkauft? Markieren Sie es als verkauft.',
    sold_empty_subtitle:
      'Wir verschieben es mit der gesamten Dokumentation hierher, damit Ihre Lagerliste übersichtlich bleibt.',
    vehicle_data: 'Fahrzeugdaten',
    source_purchased: 'Aus gekauften wählen',
    source_own: 'Eigenes Fahrzeug hinzufügen',
    brand: 'Marke',
    model: 'Modell',
    year: 'Baujahr',
    mileage: 'Kilometerstand',
    vin: 'VIN',
    choose: 'Wählen',
    mileage_placeholder: 'z. B.  2500',
    vin_placeholder: 'z. B. JYARM22E0LA001234',
    vin_tooltip: 'Fahrzeug-Identifizierungsnummer (17 Zeichen).',
    discard: 'Verwerfen',
    add: 'Hinzufügen',
    save: 'Speichern',
    km: 'km',
    ccm: 'cm³',
    kw: 'kW',
    field_integer: 'Ganze Zahl angeben',
    search_purchased: 'Motorräder suchen...',
    choose_vehicle: 'Fahrzeug wählen',
    loading_offers: 'Laden...',
    no_purchased: 'Keine Motorräder gefunden',
    field_required: 'Bitte dieses Feld ausfüllen',
    promotion: 'Promotionen',
    promotion_empty_title: 'Keine Promotionen',
    promotion_empty_subtitle:
      'Wenn das Inserat auf mobile.de oder einem anderen Portal, zum Beispiel Otomoto, steht, erscheint es hier.',
    promotion_mobile: 'mobile.de',
    promotion_otomoto: 'Otomoto',
    promotion_listed: 'Inserat ist online',
    promotion_paused: 'Pausiert',
    promotion_pause: 'Pausieren',
    promotion_resume: 'Fortsetzen',
    promotion_delete: 'Löschen',
    promotion_public_link: 'Inserat ansehen',
    add_promotion: 'Promotion hinzufügen',
    promotion_photos: 'Fotos im Inserat',
    promotion_photos_pick: 'Fotos auswählen',
    promotion_photos_none: 'Das Inserat wird ohne Fotos erstellt.',
    promotion_photos_empty: 'Dieses Fahrzeug hat keine Fotos. Füge sie auf der Fahrzeugseite hinzu.',
    promotion_photos_hint: 'Wähle Fotos aus der Galerie dieses Fahrzeugs.',
    promotion_photos_limit: 'Du kannst höchstens {{count}} Fotos auswählen.',
    promotion_photos_confirm: 'Auswahl speichern',
    promotion_photo_cover: 'Hauptbild',
    promotion_photo_make_cover: 'Als Hauptbild',
    edit_promotion: 'Promotion bearbeiten',
    promotion_form_title: 'Werbung auf mobile.de',
    promotion_price: 'Preis',
    promotion_price_placeholder: 'z. B. 12500',
    promotion_category: 'Kategorie',
    promotion_description: 'Beschreibung',
    promotion_description_placeholder: 'Beschreibung des Inserats',
    promotion_description_bold: 'Fett',
    promotion_description_list: 'Aufzählung',
    promotion_description_rule: 'Linie',
    promotion_description_undo: 'Rückgängig',
    promotion_description_redo: 'Wiederholen',
    promotion_highlight: 'Highlight',
    promotion_highlight_placeholder: 'z. B. ABS',
    promotion_section_vehicle: 'Fahrzeug',
    promotion_section_equipment: 'Ausstattung',
    promotion_section_service: 'Service',
    promotion_power: 'Leistung',
    promotion_capacity: 'Hubraum',
    promotion_drive_type: 'Antrieb',
    promotion_gear_box: 'Getriebe',
    promotion_color: 'Farbe',
    promotion_metallic: 'Metallic-Lack',
    promotion_vat: 'MwSt.',
    promotion_damage: 'Unreparierte Schäden',
    promotion_abs: 'ABS',
    promotion_heated_grips: 'Griffheizung',
    promotion_box: 'Topcase',
    promotion_windshield: 'Windschild',
    promotion_kickstarter: 'Kickstarter',
    promotion_owners: 'Anzahl Vorbesitzer',
    promotion_last_inspection: 'Letzte Inspektion',
    promotion_new_inspection: 'Neue HU',
    promotion_service_history: 'Vollständiges Serviceheft',
    promotion_yes: 'Ja',
    promotion_no: 'Nein',
    promotion_month_placeholder: 'JJJJ-MM',
    promotion_months: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember'
    ],
    promotion_vat_23: '23%',
    promotion_vat_19: '19%',
    promotion_vat_none: 'MwSt. nicht ausweisbar',
    promotion_gear_manual: 'Schaltgetriebe',
    promotion_gear_automatic: 'Automatik',
    promotion_drive_chain: 'Kette',
    promotion_drive_belt: 'Riemen',
    promotion_drive_shaft: 'Kardan',
    promotion_colors: {
      BLACK: 'Schwarz',
      GREY: 'Grau',
      BEIGE: 'Beige',
      BROWN: 'Braun',
      RED: 'Rot',
      GREEN: 'Grün',
      BLUE: 'Blau',
      PURPLE: 'Violett',
      GOLD: 'Golden',
      WHITE: 'Weiß',
      ORANGE: 'Orange',
      SILVER: 'Silber',
      YELLOW: 'Gelb'
    },
    promotion_create_error: 'Die Promotion auf mobile.de konnte nicht hinzugefügt werden.',
    promotion_update_error: 'Die Promotion auf mobile.de konnte nicht gespeichert werden.',
    toast_promotion_added: 'Promotion auf mobile.de wurde hinzugefügt',
    toast_promotion_updated: 'Promotion auf mobile.de wurde aktualisiert',
    toast_promotion_paused: 'Das Inserat wurde auf mobile.de pausiert',
    toast_promotion_deleted: 'Das Inserat wurde von mobile.de entfernt',
    toast_promotion_resumed: 'Das Inserat wurde wieder auf mobile.de veröffentlicht',
    promotion_categories: {
      ChopperAndCruiser: 'Chopper/Cruiser',
      CombinationAndSidecar: 'Gespann/Seitenwagen',
      DirtBike: 'Dirt Bike',
      EnduroAndTouringEnduro: 'Enduro/Reiseenduro',
      LightweightMotorcycleAndMotorbike: 'Klein/Leichtkraftrad',
      MotorAssistedBicycleAndSmallMoped: 'Mofa/Mokick/Moped',
      Motorcycle: 'Motorrad',
      NakedBike: 'Naked Bike',
      Pocketbike: 'Pocket Bike',
      Racing: 'Rennsport',
      RallyAndCross: 'Rallye/Cross',
      Scooter: 'Roller/Scooter',
      SportTouringMotorcycle: 'Sporttourer',
      SportsAndSuperSportsBike: 'Sportler/Supersportler',
      Streetfighter: 'Streetfighter',
      SuperMoto: 'Super Moto',
      Tourer: 'Tourer',
      Trike: 'Trike',
      OtherMotorbike: 'Andere',
      Quad: 'Quad'
    },
    add_document: 'Dokument hinzufügen',
    document_invoice: 'Rechnung',
    document_sell_contract: 'Kaufvertrag',
    document_import: 'Importdokument',
    document_open: 'Öffnen',
    document_download: 'Herunterladen',
    documents_empty_title: 'Erstes Dokument hinzufügen',
    documents_empty_subtitle: 'Hier stellen Sie Rechnung, Vertrag und Importdokument für dieses Motorrad aus.'
  },
  clients: {
    title: 'Kunden',
    add_client: 'Kunde hinzufügen',
    name: 'Kundenname',
    email: 'E-Mail',
    phone: 'Telefonnummer',
    country: 'Land',
    actions: 'Aktionen',
    details: 'Kundendetails',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    copy_email: 'E-Mail kopieren',
    email_copied: 'Kopiert',
    empty_title: 'Ersten Kunden hinzufügen',
    empty_subtitle: 'Kunden erscheinen hier, nachdem Sie sie hinzugefügt haben.',
    edit_client: 'Kunde bearbeiten',
    client_data: 'Kundendaten',
    company: 'Firma',
    personal: 'Privatperson',
    company_name: 'Firmenname',
    document_number: 'Dokumentnummer',
    vat_number: 'USt-IdNr.',
    id_number: 'Ausweisnummer',
    place: 'Ort',
    zip_code: 'Postleitzahl',
    street: 'Straße',
    house_number: 'Hausnummer',
    first_name: 'Vorname',
    last_name: 'Nachname',
    company_name_placeholder: 'z. B. AutoMoto GmbH',
    document_number_placeholder: 'z. B. 12/345/67890',
    vat_number_placeholder: 'z. B. DE123456789',
    id_number_placeholder: 'z. B. T220001293',
    place_placeholder: 'z. B. Berlin',
    zip_code_placeholder: 'z. B. 10115',
    street_placeholder: 'z. B. Friedrichstraße',
    house_number_placeholder: 'z. B. 12a',
    first_name_placeholder: 'z. B. Thomas',
    last_name_placeholder: 'z. B. Müller',
    email_placeholder: 'z. B. t.mueller@automoto.de',
    phone_placeholder: 'z. B. +49 30 12345678',
    tax_number: 'Steuernummer',
    full_name: 'Vor- und Nachname',
    city: 'Stadt',
    documents: 'Dokumentenliste',
    documents_empty_subtitle: 'Hier stellen Sie Rechnung, Kaufvertrag und Importdokument für diesen Kunden aus.',
    search: 'Suchen',
    document_invoice: 'Rechnung',
    document_contract: 'Vertrag',
    document_import: 'Importdokument',
    countries: {
      poland: 'Polen',
      germany: 'Deutschland'
    }
  },
  sell_contract: {
    contract_data: 'Vertragsdaten',
    vehicle: 'Fahrzeug',
    client: 'Kunde',
    contract_language: 'Vertragssprache',
    select: 'Auswählen',
    select_client: 'Kunden auswählen',
    select_vehicle: 'Fahrzeug auswählen',
    search_clients: 'Kunden suchen...',
    no_clients: 'Keine Kunden gefunden',
    currency: 'Währung',
    vat_rate: 'MwSt.-Satz',
    price: 'Preis',
    gross: 'Brutto',
    net: 'Netto',
    net_price: 'Nettopreis',
    vat: 'MwSt. ({{rate}}%)',
    gross_price: 'Bruttopreis',
    additional_services: 'Zusätzliche Leistungen',
    additional_service_name: 'Bezeichnung',
    additional_service_amount: 'Betrag',
    additional_service_add: 'Leistung hinzufügen',
    additional_service_remove: 'Entfernen',
    additional_service_total: 'Gesamtpreis',
    down_payment: 'Anzahlung',
    down_payment_amount: 'Anzahlungsbetrag',
    payment_method: 'Zahlungsmethode',
    payment_type: 'Zahlungsart',
    bank_transfer: 'Überweisung',
    instant_transfer: 'Echtzeitüberweisung',
    cash: 'Bar',
    financing: 'Finanzierung',
    date: 'Datum',
    on_contract: 'Vertrag',
    down_payment_date: 'Anzahlungsdatum',
    delivery: 'Lieferung',
    date_format: 'Datumsformat',
    exact_date: 'Genaues Datum',
    time_span: 'Zeitraum',
    delivery_date: 'Lieferdatum',
    delivery_period: 'Lieferzeitraum',
    commitment: 'Verbindlichkeit',
    binding: 'Verbindlich',
    non_binding: 'Unverbindlich',
    delivery_method: 'Lieferart',
    delivery_place: 'Ort oder Lieferanschrift',
    additional_service_delivery_cost: 'Das sind die Übergabekosten',
    payment_due: 'Fälligkeit',
    payment_due_handover: 'Bei Übergabe gegen Rechnung',
    payment_due_custom: 'Anderer Termin',
    payment_due_text: 'Vereinbarter Termin',
    registration_state: 'Zulassungsstand bei Übergabe',
    registration_deregistered: 'Abgemeldet',
    registration_registered: 'Zugelassen',
    registration_by: 'Zulassung nimmt vor',
    registration_seller: 'Verkäufer',
    registration_buyer: 'Käufer',
    client_delivery: 'Kundenabholung',
    dealer_delivery: 'Händlerlieferung',
    damages: 'Schäden und Abweichungen',
    remarks: 'Bemerkungen / Sonstiges',
    remarks_hint: 'Hier kannst du bekannte Mängel, Schäden, Probleme und sonstige Hinweise zum Fahrzeug eintragen.',
    previous_owner_damages: 'Schäden und Abweichungen des Vorbesitzers',
    yes: 'Ja',
    no: 'Nein',
    not_specified: 'Nicht angegeben',
    exclude_updates:
      'Soll die Pflicht zur Aktualisierung digitaler Produkte und Waren mit digitalen Elementen ausgeschlossen werden?',
    shorten_warranty: 'Gewährleistung auf ein Jahr verkürzen',
    language_de: 'Deutsch',
    language_pl: 'Polnisch',
    vat_23: '23% MwSt.',
    vat_10: '10% MwSt.',
    vat_5: '5% MwSt.',
    vat_marginal: 'Differenzbesteuerung',
    vat_small_business: 'Kleinunternehmer',
    month_1: '1 Monat',
    month_2: '2 Monate',
    month_3: '3 Monate',
    month_4: '4 Monate',
    month_5: '5 Monate',
    description: 'Beschreibung',
    objective_deviations: 'Gibt es Abweichungen von den objektiven Anforderungen?',
    objective_deviation_1: 'Beschreibung der Abweichung',
    objective_deviation_placeholder: 'Bauteil, Zustand und Nutzungsfolgen',
    further_agreements: 'Weitere Beschaffenheitsvereinbarungen',
    further_agreements_placeholder: 'Leer lassen, wenn nichts vereinbart wurde',
    eur: 'EUR (€)',
    pln: 'PLN (zł)',
    date_placeholder: 'TT.MM.JJJJ',
    field_required: 'Bitte dieses Feld ausfüllen',
    vin_value: 'VIN: {{vin}}',
    mileage_value: 'Kilometerstand {{mileage}}',
    year_value: 'Jahr: {{year}}',
    email_value: 'E-Mail: {{email}}',
    phone_value: 'Telefon: {{phone}}',
    address_value: 'Adresse: {{address}}',
    mileage_statement: 'Laufleistung',
    mileage_statement_known: 'Laufleistung bekannt',
    mileage_statement_unknown: 'Laufleistung nicht bekannt',
    mileage_statement_custom: 'Eigene Laufleistungsvereinbarung',
    mileage_statement_text: 'Text zur Laufleistung',
    previous_owners_basis: 'Grundlage der Angabe zu Vorhaltern',
    previous_owners_basis_placeholder: 'Unterlagen oder konkrete Informationen',
    key_count: 'Anzahl Schlüssel',
    other_equipment: 'Weiteres Zubehör',
    missing_items: 'Fehlende Unterlagen oder Teile'
  },
  unsaved_changes: {
    title: 'Sie haben ungespeicherte Änderungen',
    body: 'Wenn Sie jetzt gehen, gehen die eingegebenen Daten verloren.',
    leave: 'Ohne Speichern verlassen',
    stay: 'Zurück zur Bearbeitung'
  },
  mobile_redirect: {
    title: 'Laden Sie unsere mobile App herunter',
    subtitle: 'um aktuelle Angebote zu durchsuchen und die Plattform im Demo-Modus zu erkunden.',
    step1: 'Laden Sie die Estimoto-App auf Ihr Telefon herunter (Android/iOS).',
    step2: 'Melden Sie sich mit der',
    step2_highlight: 'gleichen E-Mail-Adresse',
    step3: 'und dem an Ihr Postfach gesendeten Passwort an.',
    step4: 'Sie erhalten Zugang zur Demo-Version und echten, aktuellen Motorradangeboten.',
    open_app: 'Mobile App öffnen',
    google_play: 'Google Play',
    app_store: 'App Store'
  },
  invoice_form: {
    sales_invoices: 'Verkaufsrechnungen',
    add_invoice: 'Rechnung hinzufügen',
    edit_invoice: 'Rechnung bearbeiten',
    invoice_data: 'Kundendaten',
    nip: 'USt-IdNr.: {{number}}',
    invoice_number: 'Rechnungsnummer',
    invoice_number_placeholder: 'z. B. RE/2026/001',
    invoice_language: 'Rechnungssprache',
    language_en: 'Englisch',
    invoice_date: 'Rechnungsdatum',
    payment_due: 'Zahlungsziel',
    additional_info: 'Zusätzliche Informationen'
  }
}
